<template>
  <div class="landing position-relative overflow-x-hidden" id="home">
    <Objectes></Objectes>
    <div class="container min-vh-100 d-flex align-items-start">
      <div class="row">
        <div class="col-12">
          <div>
            <div class="row">
              <div class="col-12 mb-3 mb-md-0">
                <img src="../assets/photo/landing/logo.png" alt="" />
              </div>
            </div>
            <div class="row flex-column-reverse flex-md-row mt-md-0 justify-content-center align-items-center">
              <div class="col-12 col-md-2">
                <div class="mt-5 mt-md-0 d-flex flex-row flex-md-column justify-content-center align-items-center px-2 px-md-0 left-contact">
                  <!-- <span class="mt-md-3 mx-1 mx-md-0"><img src="../assets/photo/landing/slack.png" alt="" /></span> -->
                  <span class="mt-md-3 mx-2 mx-md-0"
                    ><a href="https://www.facebook.com/chester.est1998/"><img src="../assets/photo/landing/facebook.png" alt="" /></a
                  ></span>
                  <!-- <span class="mt-md-3 mx-2 mx-md-0"><img src="../assets/photo/landing/messenger.png" alt="" /></span> -->
                  <span class="mt-md-3 mx-2 mx-md-0"
                    ><a href="mail:hahdev98@gmail.com"><img src="../assets/photo/landing/mail.png" alt="" /></a
                  ></span>

                  <span class="mt-md-3 mx-2 mx-md-0">
                    <a href="https://github.com/kimmichDev" target="_blink"><img src="../assets/photo/github-icon.svg" width="32" alt="" /> </a>
                  </span>
                  <h5 class="rotate-text mx-2 mb-0 text-nowrap">Meet me there</h5>
                </div>
              </div>
              <div class="col-12 col-md-10">
                <div>
                  <div class="hero-title">
                    <h5 class="text-black-50">Howdy ! I'm</h5>
                    <h1 class="fw-bold my-3">Htet Aung Hlaing &lt; / &gt;</h1>
                    <h5 class="text-black-50">Professional web developer who's passionate in programming, based in the Myanmar</h5>
                    <div class="d-flex justify-content-center align-items-center my-3">
                      <a class="my-3 d-flex justify-content-center align-items-center btn btn-primary" href="#about">
                        <p class="mb-0 me-3">About me</p>
                        <lottie-player src="https://assets9.lottiefiles.com/packages/lf20_qahravmb.json" background="transparent" speed="1.2" style="width: 30px; height: 30px" loop autoplay></lottie-player>
                      </a>
                    </div>
                  </div>
                  <div class="w-100 d-flex justify-content-center">
                    <img src="../assets/photo/landing/hero.png" class="w-75 hero" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Objectes from "../components/Objectes.vue";
export default {
  components: {
    Objectes,
  },
  setup() {
    return {};
  },
};
</script>

<style scoped>
.rotate-group {
  transform: rotate(90deg);
}
</style>
